<form #policyContent="ngForm">
    <input name="subject" type="hidden" [(ngModel)]="policy.subject" required/>
    <div class="policy-form-content">
        <div class="col-sm-48 max-height inner-t-large">
            <div class="row">
                <div class="col-sm-48 outer-b-medium">
                    <!-- TODO: Update old style format for Bootstrap forms, https://zube.io/monsido/monsido/c/22962 -->
                    <label class="control-label inner-t-mini capitalize-first-letter">
                        <span translate>Select what type of content the policy should search in</span>:
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-8">
                    <label class="col-48 btn btn-border-radius btn-secondary flat inner-t inner-b-medium"
                           (click)="checkChange('page')"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'new-policy-all-assets'}"
                    >
                        <input type="radio"
                               [(ngModel)]="currentSubject"
                               name="contentType"
                               value="page"
                               style="display:none;">
                        <span class="fas fa-globe fa-3x outer-b-small"></span><br/>
                        <span data-test="all-assets-button" class="outer-t-mini inline-block" translate>All assets</span><br/>
                        <span translate>(HTML and documents)</span>
                    </label>
                </div>
                <div class="col-8">
                    <label class="col-48 btn btn-border-radius btn-secondary flat inner-t inner-b-medium"
                           (click)="checkChange('page_html')"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'new-policy-html'}"
                    >
                        <input type="radio"
                               [(ngModel)]="currentSubject"
                               name="contentType"
                               value="page_html"
                               style="display:none;">
                        <span class="fas fa-copy fa-3x outer-b-small"></span><br/>
                        <span data-test="html-pages-button"  class="outer-t-mini inline-block" translate>HTML pages</span><br/><br/>
                    </label>
                </div>
                <div class="col-8">
                    <label class="col-48 btn btn-border-radius btn-secondary flat inner-t inner-b-medium"
                           (click)="checkChange('page_document')"
                           monEventTrigger="actionTrigger"
                           [monEventParams]="{action: 'new-policy-documents'}"
                    >
                        <input type="radio"
                               [(ngModel)]="currentSubject"
                               name="contentType"
                               value="page_document"
                               style="display:none;">
                        <span class="fas fa-file-alt fa-3x outer-b-small"></span><br/>
                        <span data-test="documents-button"  class="outer-t-mini inline-block" translate>Documents</span><br/><br/>
                    </label>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </div>
</form>
